import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-066b6168"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "area-content" };
import CloudSelect from "@/components/CloudSelect/index.vue";
import { useRegionStore } from "@/store/region";
import { getUserInfo, setGloblRegion } from "@/utils/auth";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    setup(__props) {
        const useRegion = useRegionStore();
        const region = ref();
        const list = ref([]);
        const handleRegionChange = (item) => {
            if (useRegion.getRegion.value !== item) {
                localStorage.removeItem(getUserInfo().user_id);
            }
            const localRegion = list.value.filter((v) => v.value === item)[0];
            setGloblRegion(localRegion);
            useRegion.setRegion(localRegion);
        };
        const getRegions = async () => {
            list.value = (await useRegion.getRegionList());
            const defaultRegion = useRegion.getRegion;
            region.value = defaultRegion.value;
            const localRegion = list.value.filter((v) => v.value === region.value)[0];
            setGloblRegion(localRegion);
            useRegion.setRegion(localRegion);
        };
        getRegions();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CloudSelect, {
                    modelValue: region.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((region).value = $event)),
                    options: list.value,
                    placeholder: "请选择分区",
                    onChange: handleRegionChange
                }, null, 8, ["modelValue", "options"])
            ]));
        };
    }
});
